import { t } from 'i18next';
import { atom } from 'recoil';
import { MetricGroupConfig, MetricGroupId } from './actuality.types';
import { getMetricGroupConfig } from './metricGroups.config';

const config = getMetricGroupConfig(t);
const defaultOrder = Object.entries(config).reduce(
  (acc, [id, group]) => ({ ...acc, [id]: group.order }),
  {} as Record<MetricGroupId, number>,
);

export const metricGroupsConfigState = atom<
  Record<MetricGroupId, MetricGroupConfig>
>({
  key: 'metricGroupsConfigState',
  default: config,
});

export const hiddenMetricGroupsState = atom<MetricGroupId[]>({
  key: 'hiddenMetricGroupsState',
  default: [],
});

export const metricGroupOrderState = atom<Record<MetricGroupId, number>>({
  key: 'metricGroupOrderState',
  default: defaultOrder,
});
